<template>
  <div
    v-if="!this.$route.params.id"
    id="players-table"
    class="text-white"
    :class="`content-wrapper ${isMenuOpen ? 'menu-open' : 'menu-closed'}`"
  >
    <div
      class="content content-styles h-auto content content-styles text-white ov-visible md:mx-[1rem]"
    >
      <div class="box text-white large content-box-style ov-hidd p-0">
        <Filters
          :options="options"
          :showActionButton="true"
          :search="search"
          :resetFilter="resetFilter"
          :resetPagination="resetPagination"
        />
        <button v-if="0" @click="createPlayer(true)">Create Player</button>

        <div
          v-if="isLoading"
          class="flex flex-col items-center justify-center p-20 space-y-4"
        >
          <Loader />
        </div>

        <div
          v-else
          class="table-container-custom shadow-md rounded-2xl overflow-hidden border border-gray-700 my-4 bg-gray-900"
        >
          <DataTable
            :value="tableData"
            :loading="isLoading"
            :lazy="true"
            :paginator="true"
            :rows="selectedLimit"
            :totalRecords="totalElements"
            :first="(currentPage - 1) * selectedLimit"
            dataKey="_id"
            @page="onPage"
            paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
            :rowsPerPageOptions="[15, 25, 50, 100]"
            currentPageReportTemplate="Showing {first} to {last} of {totalRecords} players"
            showCurrentPageReport
            stripedRows
            scrollable
            scrollHeight="flex"
            class="freebets-datatable p-datatable-sm"
          >
            <!-- Colonne Standard -->
            <Column
              v-for="col in columns.filter(
                (c) => c.type !== 'action_button' && c.type !== 'date',
              )"
              :key="col.slug"
              :field="col.slug"
              :header="col.label"
              class="text-black"
            />

            <!-- Colonne Data -->
            <Column
              v-for="col in columns.filter((c) => c.type === 'date')"
              :key="col.slug"
              :field="col.slug"
              :header="col.label"
            >
              <template #body="slotProps">
                <span class="text-black text-sm">
                  {{
                    slotProps.data[col.slug]
                      ? new Date(slotProps.data[col.slug]).toLocaleString()
                      : "-"
                  }}
                </span>
              </template>
            </Column>

            <!-- Colonna Azioni con Button PrimeVue -->
            <Column
              v-for="col in columns.filter((c) => c.type === 'action_button')"
              :key="col.label"
              :header="col.label"
            >
              <template #body="slotProps">
                <Button
                  :icon="`pi pi-${col.buttonType.icon || 'eye'}`"
                  rounded
                  text
                  severity="info"
                  v-tooltip.top="'View Details'"
                  @click="openPlayerDetail(slotProps.data)"
                  class="hover:bg-blue-300/40 rounded-full"
                />
              </template>
            </Column>
          </DataTable>
        </div>
      </div>
    </div>
  </div>

  <div
    v-else
    :class="`content-wrapper h-auto ${
      isMenuOpen ? 'menu-open' : 'menu-closed'
    }`"
  >
    <div class="round-details-container player-detail-content-wrapper">
      <div class="round-id-information-wrapper">
        <div class="table-wrapper">
          <PlayerDetail />
        </div>
      </div>
    </div>
  </div>

  <PlayerManager v-if="playerManagerOpen" :createPlayer="createPlayer" />
</template>

<script>
import DataTable from "primevue/datatable";
import Column from "primevue/column";
import Button from "primevue/button";
import Loader from "../components/Loader.vue";
import PlayerDetail from "../components/PlayerDetail.vue";
import Filters from "../components/table/Filters.vue";
import { mapGetters } from "vuex";
import { getFetch } from "@/api/axiosClient";
import PlayerManager from "../components/PlayerManager.vue";

export default {
  name: "PlayersPage",
  components: {
    PlayerDetail,
    Filters,
    PlayerManager,
    DataTable,
    Column,
    Button,
    Loader,
  },
  computed: {
    ...mapGetters(["isMenuOpen", "allowedSkins", "skinStorage"]),
  },
  data() {
    return {
      currentPage: 1,
      totalPages: 1,
      player_id: null,
      skinFilt: "",
      is_test: "All",
      status: "All",
      sortby: "First New",
      frozen_at: null,
      bet_id: "",
      start_date: null,
      end_date: null,
      tableData: [],
      isLoading: false,
      showDetailModal: false,
      modalTitle: "",
      totalElements: 0,
      playerManagerOpen: false,
      selectedLimit: 15,
      base_columns: [],
      player_column: [
        { slug: "user_id", type: "text", label: "Player ID", button: false },
        { slug: "status", type: "text", label: "Status", button: false },
        { slug: "currency", type: "text", label: "Currency", button: false },
      ],
      advanced_column: [
        {
          slug: "created_at",
          type: "date",
          isDate: true,
          label: "First Connection",
          button: false,
        },
        {
          slug: "updated_at",
          type: "date",
          isDate: true,
          label: "Last Connection",
          button: false,
        },
      ],
      action_column: [
        {
          type: "action_button",
          label: "Detail",
          button: true,
          buttonType: {
            icon: "eye",
            action: "openPlayerDetail",
          },
        },
      ],
      columns: [],
      options: [
        {
          label: "Player ID",
          type: "text",
          placeholder: "Search for Player ID",
          property: "player_id",
        },
        {
          label: "Status",
          type: "select",
          placeholder: "Choose status",
          property: "status",
          options: ["All", "Active", "Blocked", "Frozen", "Banned"],
        },
        {
          label: "Is Test",
          type: "select",
          placeholder: "Choose Type",
          property: "is_test",
          options: ["All", "Test", "Casual"],
        },
      ],
    };
  },
  methods: {
    async search() {
      await this.generateColumns();
      this.isLoading = true;
      try {
        const params = {
          page: this.currentPage,
          limit: this.selectedLimit,
        };

        if (this.skinFilt && this.skinFilt !== "") {
          params.skin_id = this.skinFilt.trim();
        }

        if (this.player_id && this.player_id.trim() !== "") {
          params.user_id = this.player_id.trim();
        }

        if (this.status !== "All") {
          params.status = this.status.toLowerCase();
        }

        if (this.is_test !== "All") {
          params.is_test = this.is_test === "Test" ? "test" : "false";
        }

        const data = await getFetch("players/", params);

        this.tableData = data.data;
        this.totalPages = data.totalPages;
        this.totalElements = data.totalItems;
      } catch (error) {
        console.error("Errore durante il fetch dei dati:", error);
      } finally {
        this.isLoading = false;
      }
    },
    async onPage(event) {
      this.selectedLimit = event.rows;
      this.currentPage = event.page + 1;
      await this.search();
    },
    async resetPagination() {
      this.currentPage = 1;
    },
    async changePage(page) {
      this.currentPage = page;
      await this.search();
    },
    async resetFilter() {
      this.is_test = "All";
      this.status = "All";
      this.frozen_at = null;
      this.player_id = null;

      await this.resetPagination();
      await this.search();
    },
    async generateColumns() {
      this.columns = [
        ...this.player_column,
        ...this.base_columns,
        ...this.advanced_column,
        ...this.action_column,
      ];
    },
    openPlayerDetail(row) {
      let player_id = row._id;
      const lang = this.$route.params.lang || "en";
      const skin = this.$route.params.skinFilt || this.skinStorage;
      const skinPath = skin && skin !== "all" ? `/${skin}` : "";
      const section =
        this.$route.meta?.section ||
        (this.$route.path.includes("/livecasino")
          ? "livecasino"
          : this.$route.path.includes("/instant")
          ? "instant"
          : "slot");
      setTimeout(() => {
        window.open(`/${lang}${skinPath}/${section}/players/${player_id}`, "_blank");
      });
    },
    async checkSkinFromUrl() {
      const params = new URLSearchParams(window.location.search);
      const skinFromQuery = params.get("skin_id");
      const paramSkin = this.$route.params.skinFilt;
      this.skinFilt = skinFromQuery ?? (paramSkin && paramSkin !== "all" ? paramSkin : this.skinStorage ?? "");
    },
    createPlayer(val) {
      this.playerManagerOpen = val;
    },
  },
  mounted() {
    this.checkSkinFromUrl();
    this.search();
  },
};
</script>
